// extracted by mini-css-extract-plugin
export default {"errorModalContent":"styles_error-modal-content__VbXhN","errorModalContent__errorsList":"styles_error-modal-content__errors-list__m+1TP"};